export let ETabEarnRoutes=function(ETabEarnRoutes){ETabEarnRoutes["EarnHome"]="EarnHome";return ETabEarnRoutes;}({});